export default __webpack_public_path__ + "static/media/hybrid_and_balanced.92b10d87.svg";